import {
    ChallengingSituationsACF,
    ConditionPostTypeACF,
    LocalInformationPostTypeACF,
    // LocalListingPostTypeACF,
    PopulationPostTypeACF,
    ListingAcf,
} from "../../../constants/types/acf";
import { fetchPostType, fetchservicesInRegion } from "../services";
import { StoreApi } from "../types";

export const getPopulations = () => async ({ setState }: StoreApi) => {
    const posts = await fetchPostType<PopulationPostTypeACF>("population");
    setState({ populations: posts });
};

export const getConditions = () => async ({ setState }: StoreApi) => {
    const posts = await fetchPostType<ConditionPostTypeACF>("disorder-or-concern");
    setState({ conditions: posts });
};

export const getLocalInformation = () => async ({ setState }: StoreApi) => {
    const posts = await fetchPostType<LocalInformationPostTypeACF>("local-information");
    setState({ localInformation: posts });
};

export const getFeaturedServices = () => async ({ setState }: StoreApi) => {
    const posts = await fetchPostType<ListingAcf>("listing");
    setState({ featuredServices: posts });
};

export const getServicesInregion = () => async ({ setState }: StoreApi) => {
    const posts = await fetchservicesInRegion<ListingAcf>("listing");
    setState({ servicesInRegion: posts });
};

export const getChallengingSituations = () => async ({ setState }: StoreApi) => {
    const posts = await fetchPostType<ChallengingSituationsACF>("situations");
    setState({ challengingSituations: posts });
};

export const getPostTypeData = () => async ({ dispatch }: StoreApi) => {
    await Promise.all([
        dispatch(getPopulations()),
        dispatch(getConditions()),
        dispatch(getFeaturedServices()),
        dispatch(getServicesInregion()),
        dispatch(getChallengingSituations()),
        dispatch(getLocalInformation()),
    ]);
};
